/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     IM 即时通讯
  +--------------------------------------------------------------------------------------
*/

import { getAccessToken } from '@/utils/cookie'
import { ssidv1 } from '@/utils/common'


var im = {
  ws: null,
  readyState: -1,   // 通道状态：-1=未曾建立、0=正在建立、1=已建立、2=正在关闭、3=已关闭
  client_id: null,  // 通道连接ID
  session_id: null, // 登录态秘钥
  loginState: 0,    // 登录态标识

  failedQueue: [],  // 发送失败消息缓存队列
  reconnectCt: 5,   // 重连周期
  reconnecting: 0,  // 重连标识：1=正在重连 -1=禁止重连 0=正常

  timerId: null,
  pingCounter: 0,   // 心跳计时器
  pingCt: 10,       // 心跳周期

  subs: {},         // Push订阅对象


  /**
   * 初始化连接
   */
   initWs() {
    var _im = this
    this.ws = new WebSocket(process.env.VUE_APP_IM_HOST)
    this.reconnecting = 0
    this.readyState = 0
  
    this.ws.onopen = e => _im.onOpen(e)
    this.ws.onmessage = e => _im.onMessage(e)
    this.ws.onerror = e => _im.onError(e)
    this.ws.onclose = e => _im.onClose(e)
  },

  /**
   * 重连
   */
   reconnect() {
    if (this.reconnecting === -1) return
    if (this.reconnecting) return
    this.reconnecting = 1
    var _im = this
    setTimeout(() => {
      _im.initWs()
    }, _im.reconnectCt * 1000)
    console.log('im reconect 5s later', _im)
  },

  onOpen(e) {
    // console.log('im open', e, new Date())
    this.readyState = 1
    this.login()
  },

  onError(e) {
    console.log('im error', e, new Date())
  },

  onClose(e) {
    console.log('im close', e, new Date())
    this.readyState = 3
    this.loginState = 0
    this.clear()
    this.reconnect()
  },

  onMessage(e) {
    var res = JSON.parse(e.data)
    if (!res || !res.cado) return

    // 自动ACK
    if (res.cado.indexOf('_push') > -1) {
      this.cadoPushAutoAck({ ssid: res.ssid })
    }

    // 内置R响应方法执行
    var r_cado = 'R_' + res.cado.toUpperCase()
    if (this.hasOwnProperty(r_cado)) {
      this[r_cado](res)
    }

    // Callback响应方法执行，若订阅存在subs对象中
    if (this.subs.hasOwnProperty(res.ssid) && this.subs[res.ssid].callback) {
      this.subs[res.ssid].callback(res)
      // 清除只订阅一次的sub
      if (this.subs[res.ssid].once) {
        delete this.subs[res.ssid]
        // console.log('im subs update-', this.subs)
      }
    }

    // 重置心跳
    if (this.timerId) this.pingCounter = 0
  },

  send(data) {
    return new Promise((resolve, reject) => {
      if (!data.ssid) data.ssid = ssidv1()
      if (this.ws && this.readyState === 1 && this.loginState === 1) {
        // 直接发送
        this.ws.send(JSON.stringify(data))
        resolve(data.ssid)
      } else {
        // 失败暂存
        const whitelist = ['equip_sensor_set', 'auth_user_ping']
        if (whitelist.indexOf(data.cado) == -1) {
          this.failedQueue.push(data)
        }
        resolve(data.ssid)
      }
    })
  },

  login() {
    const data = {
      cado: 'auth_user_login',
      ssid: ssidv1(),
      payload: {
        access_token: getAccessToken(),
        session_id: this.session_id
      }
    }
    this.ws.send(JSON.stringify(data))
  },
  R_AUTH_USER_LOGIN(res) {
    if (!res.errno) {
      this.client_id = res.data.client_id
      this.session_id = res.data.session_id
      this.loginState = 1

      // 启动心跳定时
      this.timerId = setInterval(() => {
        this.pingCounter += 1
        if (this.pingCounter >= this.pingCt) {
          this.pingCounter = 0
          this.ping()
        }
      }, 1000)

      // 重发队列
      if (this.failedQueue.length > 0) {
        while (this.failedQueue.length) {
          this.send(this.failedQueue.shift())
        }
        // console.info('im failed queue update', this.failedQueue)
      }
    }
  },

  ping() {
    this.send({
      cado: 'auth_user_ping',
      payload: {
        timestamp: +new Date()
      }
    })
  },

  logout() {
    this.send({
      cado: 'auth_user_logout',
    })
  },

  /**
   * 主动关闭通道
   */
   close() {
    if (this.ws && this.readyState === 1) {
      this.ws.close()
      this.reconnecting = -1
    }
  },

  /**
   * 清理秒定时器
   */
   clear() {
    if (this.timerId) {
      clearInterval(this.timerId)
      this.timerId = null
    }
  },

  /**
   * 订阅
   */
  cadoSub(pl, callback, once = false) {
    const _im = this
    return new Promise((resolve, reject) => {
      if (!pl || !pl.cado) reject(false)
      const data = {
        cado: pl.cado,
        payload: pl.payload
      }
      this.send(data).then(ssid => {
        if (ssid) {
          // 若订阅有Sub响应或Push响应的回调处理，则保存至subs对象中
          if (callback) {
            _im.subs[ssid] = {
              ssid: ssid,
              cado: pl.cado,
              payload: pl.payload,
              callback: callback,
              once
            }
            // console.log('im subs update+', _im.subs)
          }
          resolve(ssid)
        } else {
          reject(false)
        }
      })
    })
  },
  cadoSubOnce(pl, callback) {
    return this.cadoSub(pl, callback, true)
  },

  /**
   * 取消单项订阅
   */
  cadoUnsubOne(payload) {
    const _im = this
    return new Promise((resolve, reject) => {
      const data = {
        cado: 'sub_unsub_one',
        payload
      }
      this.send(data).then(ssid => {
        if (_im.subs.hasOwnProperty(payload.ssid)) {
          delete _im.subs[payload.ssid]
          // console.log('im subs update-', _im.subs)
        }
        resolve(ssid)
      })
    })
  },

  /**
   * 取消所有订阅
   */
  cadoUnsubAll() {
    const _im = this
    return new Promise((resolve, reject) => {
      const data = {
        cado: 'sub_unsub_all',
        payload: {}
      }
      this.send(data).then(ssid => {
        _im.subs = {}
        resolve(ssid)
      })
    })
  },

  /**
   * Push自动应答
   */
  cadoPushAutoAck(payload) {
    this.send({
      cado: 'sub_push_ack',
      payload
    })
  },

}

export default im
